import * as Roles from '@/store/roles';

export const keywordActionsPermissions = {
  createKeyword: [Roles.Admin],
  saveKeywordProperties: [Roles.Admin],
  loadKeyword: [Roles.Any],
  keywordUpdate: [Roles.Admin],
  updateStateKeyword: [Roles.Any],
};



// WEBPACK FOOTER //
// ./src/store/keyword/keywordActionsPermissions.js